import React from 'react'

export default function Absec2() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>
                    <div>
                        <h3>Our Mission</h3>
                        <p>To protect the environment from harmful new invasive species through prevention and early action. 
                        </p>
                    </div>

                    <div>
                        <h3>Our Vision</h3>
                        <p>The vision of the National Invasive Species Strategy and Action Plan is that: 
                            Antigua-Barbuda-Redonda have a biosecurity system that stops new invasive alien species and reduces the impacts of existing invasive species.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
